import styles from './TrendsBlogsCta.module.css'
import Image from 'next/image'
import blogCtaBg from '../../../public/assets/images/blogCtaBg.svg'
import { staticLoader } from '@/lib/helpers/imageLoader'
export function TrendsBlogsCta() {
    return <div className={`${styles.blogDesignCta} ctaForm`}>
        <p className={styles.head}>Grab your free design <br />consultation today!</p>
        <button className={`btn font12 `}>Book Now</button>
        <figure className={`${styles.bgCta} ctaForm`}>
            <Image
                src={blogCtaBg}
                height={220}
                width={252}
                alt="blogUser"
                loader={staticLoader}
                className="img-responsive"
            />
        </figure>
    </div>
}